import React from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { fadeInLeft, fadeInRight } from "../../utility/framerAnimations";
import './LendingPartnerSection.css';

const LendingPartnerHeroSection = () => {
    const { t } = useTranslation('lenderPage');
    
    return (
        <Container>
        <section className='section-container'> 
            <div className='lender-hero-section'>
                <motion.div 
                    className="left-lender-hero-section"
                    variants={fadeInLeft}
                    initial="hidden"
                    animate="visible"
                >
                    <div className="left-lender-hero-section-content">
                        {t('left-lender-hero-section.line1')} <span>{t('left-lender-hero-section.line2')}</span>{t('left-lender-hero-section.line3')}
                        <p>{t('left-lender-hero-section.line4')}</p>
                    </div> 
                </motion.div>
                        
                <motion.div 
                    className="right-lender-hero-section"
                    variants={fadeInRight}
                    initial="hidden"
                    animate="visible"
                >
                    <div className="right-lender-hero-section-content">
                        <img src="/images/bankIMG.png" alt="Bank Building" />
                    </div>
                </motion.div> 
            </div>    
        </section>
        </Container>
    );
};

export default LendingPartnerHeroSection;
